import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { DoodApiError } from '@shared/interfaces/error.interface';
import { BogofData } from './bogof.state';

export const BOGOF_STORE_API_ACTIONS = createActionGroup({
  source: 'Dood/API/Bogof',
  events: {
    'Load Bogof Loading': emptyProps(),
    'Load Bogof Success': props<BogofData>(),
    'Load Bogof Failure': props<{ error: DoodApiError }>(),
  },
});
